module.exports = __webpack_public_path__ + "static/media/yearm.56752f4f.png";